/**
 * Item at `index`, wrapping around the list. Art arrays (icons, colors, tilts) sit beside
 * localized copy lists; if copy gains an item, it reuses art instead of crashing.
 * The non-empty tuple type makes an empty art list a compile error.
 */
export const cycle = <T>(items: readonly [T, ...T[]], index: number): T => items[index % items.length];
